export const AppTheme = {
  PRIMARY_COLOR: "#FC4613",
  PRIMARY_LIGHT: "#FFE9E3",
  PRIMARY_WHITE: "#FFFFFF",
  PRIMARY_BLACK: "#000000",
  PRIMARY_INFO: "#3B82F6",
  PRIMARY_ERROR: "#991b1b",
  PRIMARY_ERROR_LIGHT: "#B91c1c",

  // Other Utilities
  SIDEBAR_HOVER: "#ffede7",
  BORDER_COLOR: "#0000001f",
  NESTED_SIDEBAR_ELE_COLOR: "#4B4B4B",
  DISABLED_FIELD_COLOR: "#f2f2f2",
  TABLE_HERDER_LABEL_COLOR: "#717680",
  TABLE_HERDER_BACKGROUND_COLOR: "#FAFAFA",
  SUBTITLE_COLOR: "#4B4B4B",
  FILTER_BUTTON_COLOR: "#858484",
  DISABLE_BUTTON_COLOR: "#F6F7F8",
}

// Font size for @mui/x-data-grid data table
export const MuiDataGridFontSize = "12px"

// Style for @mui/x-data-grid data table
export const MuiDataGridStyle = {
  borderRadius: "8px",
  "& .MuiDataGrid-columnHeader": {
    backgroundColor: "rgba(224, 224, 224, 0.4)",
    fontSize: MuiDataGridFontSize,
  },
  "& .MuiDataGrid-cell": {
    fontSize: MuiDataGridFontSize, // Adjust cell font size globally
  },
  "& .MuiTablePagination-root, & .MuiTablePagination-caption": {
    fontSize: MuiDataGridFontSize,
  },
  "& .MuiTablePagination-selectLabel": {
    fontSize: MuiDataGridFontSize,
  },
  "& .MuiTablePagination-displayedRows": {
    fontSize: MuiDataGridFontSize,
  },
  "& .MuiDataGrid-row:hover": {
    backgroundColor: "transparent !important",
  },
  "& .MuiDataGrid-scrollbar": {
    zIndex: 1,
  }
};